import React from 'react';
import { JsonObject } from '../../definitions/JsonObject';
interface TabListProps {
  content: JsonObject;
  notificationCount: number;
  messageCount: number;
}
export default function TabList({ content, notificationCount, messageCount }: TabListProps) {
  let notificationTabHeader = content.notificationsTabHeader || '';
  let messageTabHeader = content.messagesTabHeader || '';
  if (!notificationCount) {
    notificationCount = 0;
  }

  if (!messageCount) {
    messageCount = 0;
  }
  notificationTabHeader = notificationTabHeader.replace('{count}', notificationCount);
  messageTabHeader = messageTabHeader.replace('{count}', messageCount);

  return (
    <div id="cw_tab-list" className="cw_tab-list">
      <button
        id="cw_tab-notifications"
        data-panel="cw_panel-notifications"
        className="cw_tab cw_tab_notifications cw_tab_selected"
        data-pagename="main:notifications:toggleNotifs"
        dangerouslySetInnerHTML={{ __html: notificationTabHeader }}
      />
      <button
        id="cw_tab-messages"
        data-panel="cw_panel-messages"
        className="cw_tab cw_tab_messages"
        data-pagename="main:notifications:toggleSMC"
        dangerouslySetInnerHTML={{ __html: messageTabHeader }}
      />
    </div>
  );
}
